import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingWizard from '../components/OnboardingWizard';
import theme from '../theme';
import { Settings, Shield } from 'lucide-react';

const AdminOnboarding = ({ setUser }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    fundFeePercent: 0.9,
    thirdwebEnabled: true,
    twoFactorEnabled: false
  });

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleComplete = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${BACKEND_URL}/api/onboarding/admin/complete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(formData)
      });
      
      if (res.ok) {
        const data = await res.json();
        // P2.1: Update user state with returned user data
        if (data.user && setUser) {
          setUser(data.user);
        }
        navigate('/admin/dashboard');
      } else {
        alert('Onboarding failed. Please try again.');
      }
    } catch (error) {
      console.error('Onboarding error:', error);
      alert('Error completing onboarding');
    }
  };

  const steps = [
    {
      label: 'Org Settings',
      content: (
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', background: `${theme.colors.primary}15`, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Settings size={24} color={theme.colors.primary} />
            </div>
            <div>
              <h3 style={{ fontFamily: theme.fonts.heading, fontSize: '20px', fontWeight: '600', color: theme.colors.text.primary }}>Org Settings</h3>
              <p style={{ fontSize: '14px', color: theme.colors.text.secondary }}>Configure platform defaults</p>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: theme.colors.text.primary, marginBottom: '8px' }}>Global Fund Management Fee (%)</label>
              <input type="number" step="0.1" value={formData.fundFeePercent} onChange={(e) => setFormData({...formData, fundFeePercent: parseFloat(e.target.value)})} style={{ width: '100%', padding: '12px 16px', border: `1px solid ${theme.colors.borders}`, borderRadius: theme.radius.md, fontSize: '15px', outline: 'none' }} />
              <p style={{ fontSize: '12px', color: theme.colors.text.muted, marginTop: '6px' }}>Default: 0.9%</p>
            </div>
            <div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
                <input type="checkbox" checked={formData.thirdwebEnabled} onChange={(e) => setFormData({...formData, thirdwebEnabled: e.target.checked})} style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: theme.colors.text.primary }}>Enable Real Thirdweb Deployment</div>
                  <div style={{ fontSize: '13px', color: theme.colors.text.secondary }}>Deploy NFT contracts to blockchain</div>
                </div>
              </label>
            </div>
          </div>
        </div>
      )
    },
    {
      label: 'Admin Profile',
      content: (
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <div style={{ width: '48px', height: '48px', background: `${theme.colors.primary}15`, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Shield size={24} color={theme.colors.primary} />
            </div>
            <div>
              <h3 style={{ fontFamily: theme.fonts.heading, fontSize: '20px', fontWeight: '600', color: theme.colors.text.primary }}>Profile & 2FA</h3>
              <p style={{ fontSize: '14px', color: theme.colors.text.secondary }}>Secure your admin account</p>
            </div>
          </div>
          <div style={{ padding: '24px', border: `2px dashed ${theme.colors.borders}`, borderRadius: theme.radius.card, textAlign: 'center', background: theme.colors.bg.secondary }}>
            <p style={{ fontSize: '16px', fontWeight: '600', color: theme.colors.text.primary, marginBottom: '12px' }}>Two-Factor Authentication</p>
            <p style={{ fontSize: '14px', color: theme.colors.text.secondary, marginBottom: '16px' }}>Mock 2FA setup</p>
            <button onClick={() => setFormData({...formData, twoFactorEnabled: true})} style={{ padding: '12px 32px', background: formData.twoFactorEnabled ? theme.colors.success : theme.colors.primary, border: 'none', borderRadius: theme.radius.cta, color: '#FFF', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>{formData.twoFactorEnabled ? '✓ 2FA Enabled' : 'Enable 2FA'}</button>
          </div>
        </div>
      )
    }
  ];

  return (
    <OnboardingWizard
      steps={steps}
      currentStep={currentStep}
      onNext={() => setCurrentStep(currentStep + 1)}
      onBack={() => setCurrentStep(currentStep - 1)}
      onComplete={handleComplete}
      title="Admin Onboarding"
      subtitle="Configure platform settings"
    />
  );
};

export default AdminOnboarding;